import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import Button from '../../../../components/components-ui/Button/Button'
import { Grid, Col } from '../../../../components/Grid'
import { InputMasked } from '../../../../components/components-ui/InputMask/InputMask'
import api from '../../../../services/Api'
import { Formik, Form, Field } from 'formik'
import * as Yup from 'yup'
import 'react-toastify/dist/ReactToastify.css'
import { toast } from 'react-toastify'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'

export default function Action() {
  const { id } = useParams()
  const [nomeVeiculo, setNomeVeiculo] = useState('')

  function showAlert(notify, msg) {
    if (notify === 0) {
      toast.success(msg)
    } else {
      toast.error(msg)
    }
  }

  async function createVeiculo(values) {
    const response = await api.post('/veiculo/create', {
      veiculo: values.veiculo,
      placa: values.placa,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      navigate('/usina/veiculo')
      return
    }
    showAlert(1, response.data.msg)

  }

  async function editarVeiculo(values) {
    const response = await api.put(`/veiculo/edit/${id}`, {
      veiculo: values.veiculo,
      placa: values.placa,
    })
    if (response.data.error === 0) {
      showAlert(0, response.data.msg)
      navigate('/usina/veiculo')
      return
    }
    showAlert(1, response.data.msg)

  }

  useEffect(() => {
    async function getNomeVeiculo() {
      const response = await api.get(`/veiculo/show/${id}`)
      setNomeVeiculo(response.data)
    }
    getNomeVeiculo()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const navigate = useNavigate()
  const validadtionSchema = Yup.object().shape({
    veiculo: Yup.string().required('*Campo Obrigatório'),
    placa: Yup.string().required('*Campo Obrigatório'),
  })
  return (
    <Container>
      <h3> {id ? 'Edição de Veiculo' : 'Cadastro de Veiculo'} </h3>
      <section className={styles.action_section}>
        <Formik
          initialValues={{
            veiculo: nomeVeiculo?.veiculo,
            placa: nomeVeiculo?.placa,
          }}
          enableReinitialize={true}
          onSubmit={
            id
              ? (values) => editarVeiculo(values)
              : (values) => createVeiculo(values)
          }
          validationSchema={validadtionSchema}
        >
          {({ errors, touched }) => (
            <Form>
              <Grid>
                <Col size={12}>
                  <label> Placa </label>
                  <Field name="placa">
                    {({ field }) => <InputMasked {...field} mask="***-****" />}
                    {/* {({ field }) => <InputMasked {...field} mask="aaa-9a99" />} */}
                  </Field>
                  {errors.placa && touched.placa ? (
                    <span className={styles.alertError}>{errors.placa}</span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <label> Veiculo </label>
                  <Field type="text" name="veiculo" />
                  {errors.veiculo && touched.veiculo ? (
                    <span className={styles.alertError}>{errors.veiculo}</span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <Button type="submit" title={'Salvar'} />
                  <Button
                    type="button"
                    title="Voltar"
                    color="secondary"
                    onClick={() => {
                      navigate('/usina/veiculo')
                    }}
                  />
                </Col>
              </Grid>
            </Form>
          )}
        </Formik>
      </section>
    </Container>
  )
}
